import { render, staticRenderFns } from "./addBlackWhiteCarPlus-form.vue?vue&type=template&id=4fa67a7e&"
import script from "./addBlackWhiteCarPlus-form.vue?vue&type=script&lang=js&"
export * from "./addBlackWhiteCarPlus-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports